import { tsSampleHistory } from '../../../Typescript/DB_Interface'
import { useUserContext } from '../../../Contexts/UserConfig'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { formatValueDateTime } from '../../../Functions/FormatValues'

function SampleHistory({
  history,
  loading,
}: {
  history: tsSampleHistory[]
  loading: boolean
}) {
  const { loginConfig } = useUserContext()
  return (
    <DataGridPro
      sx={{ width: 1 }}
      rows={history}
      columns={[
        {
          field: 'HistoryDate',
          headerName: 'Date',
          flex: 1.5,
          valueFormatter: (value: any) => formatValueDateTime(value),
        },
        {
          field: 'EmployeeID',
          headerName: 'Employee',
          flex: 1,
        },
        {
          field: 'SampleStatus',
          headerName: 'Sample Status',
          flex: 2,
          valueFormatter: (value: any) =>
            getCodeSetLabelLookup(loginConfig, ['SampleStatusID'], value),
        },
        {
          field: 'HistoryText',
          headerName: 'Event',
          flex: 4,
        },
      ]}
      getRowId={(row) => row.HistoryDate + '' + row.HistoryText}
      disableColumnMenu
      autoHeight
      hideFooter
      density={'compact'}
      loading={loading}
      initialState={{
        sorting: {
          sortModel: [{ field: 'HistoryDate', sort: 'asc' }],
        },
      }}
    />
  )
}

export default SampleHistory
